<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="dialog2 = false"
              >Disagree</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
              >Agree</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    <v-progress-circular
      v-if="Loader"
      :size="70"
      :width="7"
      color="teal"
      indeterminate
    ></v-progress-circular>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <div id="auto">
            <table id="customers">
              <tr>
                <th>Step Name</th>
                <th>Tentative - Start - Date</th>
                <th>Total Days</th>
                <th>Tentative - End - Date</th>
                <th>Remarks</th>
                <th>Tentative Value (BDT)</th>
              </tr>
              <tr v-if="formSchema.length>0" v-for="(item, index) in formSchema" :key="index">
                <td style="white-space: pre-wrap;!important">
                  <b>{{ item.step_name }}</b>
                </td>
                <td>
                  <v-menu
                    v-model="dateModalLt[index].dpicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="formSchema[index].tenative_start_date"
                        label="Tentative Start Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"                        
                        @click="setEndDate($event, index)"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formSchema[index].tenative_start_date"
                      @input="dateModalLt[index].dpicker = false"
                    ></v-date-picker>
                  </v-menu>
                </td>
                  <td>
                  <v-text-field
                    label="Total Days"
                    v-model="formSchema[index].tentative_total_days" 
                    @input="getDays($event,index)"             
                  ></v-text-field>
                </td>
                <td>
                  
                  <v-menu
                  v-model="dateModalRt[index].dpicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="formSchema[index].tenative_end_date"
                        label="Tentative End Date"
                        prepend-icon="event"                        
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                  <v-date-picker 
                  :min="formSchema[index].tenative_start_date"
                  v-model="formSchema[index].tenative_end_date"
                  @input="dateModalRt[index].dpicker = false"
                  @change="setDays($event, index)"
                  >
                </v-date-picker>
              </v-menu>                  
                </td>
                <td>
                  <v-text-field
                    label="Remarks"
                    v-model="formSchema[index].remarks"                    
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    label="Tentative Value (BDT)"
                    v-model="formSchema[index].tenative_value"
                    
                  ></v-text-field>
                </td>
              </tr>
            </table>
            </div>      
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <v-btn color="primary" @click="submitEcoHeadAmount">
        Save
      </v-btn>
      <v-btn color="secondary" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="warning"  @click.native="home">Home</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
const commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";
import Axios from "axios";
import serverPath from "../../../../server-path/server-path";

export default {
  props: ["package_id", "method_id"],
  components: {
    DatePicker,
  },
  data: () => ({
    valid: true,
    /*package_id:3,
    method_id:14,*/
    dateModalRt:[
      { dpicker: false }
    ],

    dateModalLt:[
      { dpicker: false }
    ],

    e1: 0,
    show: false,
    Loader: false,
    //operation_act_id: 1,
    menu: false,
    modal: false,
    menu2: false,
    items: [],
    snackbar: false,
    color: "success",
    mode: "",
    dialog2: false,
    timeout: 3000,
    left: "left",
    message: "",
    getData: "",
    eco_head: [],
    formSchema: [],
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },

    insertData: {
      id: "",
      package_id: sessionStorage.getItem("package_info"),
      step_id: "",
      tenative_start_date: "",
      tenative_end_date: "",
      remarks: "",
      tenative_value: "",
    },
    total_value:0,
  }),

  created() {
    this.loadData();
    //this.getAllSteps();
  },

  watch: {
    package_id() {
      this.insertData.package_id = this.package_id;
    },

    method_id() {
      this.getAllSteps();      
    },
  },


  methods: {

    getAllSteps(){
      //console.log('getAllSteps = ');

      let path = serverPath.serverPath;

      this.formSchema = []
      this.dateModalRt = [];
      this.dateModalLt = [];

      let headers = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      };
      if(sessionStorage.getItem("package_status") == "new"){
          Axios.get(path + "/api/proc_execution_steps/" + this.method_id, headers)
        .then((res) => {
          let fetchData = res.data.data;
          fetchData.forEach((current, index, fetchData) => {
            this.dateModalRt.push({dpicker:false})
            this.dateModalLt.push({dpicker:false})
            current.tenative_start_date = "";
            current.tentative_total_days ="";
            current.tenative_end_date = "";
            current.remarks = "";
            current.tenative_value = "";
            current.step_id = current.id;
            current.package_id = sessionStorage.getItem("package_info")
              ? sessionStorage.getItem("package_info")
              : this.insertData.package_id;
            this.formSchema.push(current);            
          });
        })
        .catch((err) => {
          console.log(err);
        });

      this.total_value = this.formSchema.length
      return this.formSchema;
      }

      if(sessionStorage.getItem("package_status") == "update"){
        let instant_package_id = sessionStorage.getItem("package_info")
              ? sessionStorage.getItem("package_info")
              : this.package_id;
        Axios.get(path + "/api/proc_set_execution_steps/"+ instant_package_id+"/"+ this.method_id, headers)
        .then((res) => {
          let fetchData = res.data.data;
          this.formSchema = fetchData
          fetchData.forEach((current, index, fetchData) => {
            this.dateModalRt.push({dpicker:false})
            this.dateModalLt.push({dpicker:false})
            this.formSchema[index].tenative_start_date = current.start_date;
            this.formSchema[index].tentative_total_days = current.tentative_total_days;
            this.formSchema[index].tenative_end_date = current.end_date;
            this.formSchema[index].remarks = current.remarks;
            this.formSchema[index].tenative_value = current.value;
            this.formSchema[index].step_id = current.method_step_id;
            this.formSchema[index].package_id = current.package_id;
          });
          this.total_value = this.formSchema.length
          //console.log(this.total_value)
          return this.formSchema;
        })
        .catch((err) => {
          console.log(err);
        });

      // console.log(this.formSchema);
      // return this.formSchema;
      }
    },

    setEndDate(e, key){
       this.formSchema[key].tenative_end_date = ""
    },

    getDays(e,key){ 
      
      let formSchema = this.formSchema[key];

      if(e > 0 && formSchema.tenative_start_date != null){
        let sdate = formSchema.tenative_start_date
        let make_sys_date = new Date(sdate)
        let tempdate = make_sys_date.setDate(make_sys_date.getDate()+parseInt(e) -1)
        let edate = new Date(tempdate)

        console.log('edate', edate)
        formSchema.tenative_end_date = edate.toJSON().substring(0,10)

        this.nextStartDate(formSchema.tenative_end_date, key);
      }else if (e == 0) {
        let previous;
        //recursively check previous dates.
        for (let index = key-1; index >= 0; index--) {
            if(this.formSchema[index].tenative_end_date !== null) {
              previous = this.formSchema[index];
              break;
            }else {
              continue;
            }
        }
        this.setNextStartDateZeroVal(previous, key,e);
      }
    },
     
    /**
     * set next step date for 0 total days
     *
    */

    setNextStartDateZeroVal (value, key,e) {
        let prviousDate = value.tenative_end_date;
        let result = new Date(prviousDate);
          result.setDate(result.getDate() + 1);
        let nextdate = new Date(result);
        nextdate = nextdate.toJSON().substring(0,10);
        // console.log(nextdate.toJSON().substring(0,10))
        if(e && e == 0){
          this.formSchema[key].tenative_start_date = null;
          this.formSchema[key].tenative_end_date = null;
        }
        let keys = key + 1;
        this.formSchema[keys].tenative_start_date = nextdate;
    },
    
    setDays(e,key){ 
      
      var formSchema = this.formSchema[key];

      if(formSchema.tenative_start_date != null)
      {
        let date1 = new Date(formSchema.tenative_start_date); 
        let date2 = new Date(formSchema.tenative_end_date); 
        let Difference_In_Time = date2.getTime() - date1.getTime();
        let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
        formSchema.tentative_total_days = Difference_In_Days + 1 
          
        this.nextStartDate(formSchema.tenative_end_date, key);

      }

    },

    nextStartDate(date, key){
      var keys = key + 1;
      var formSchema = this.formSchema[keys];
      
      if(formSchema)
      {
        var result = new Date(date);
        result.setDate(result.getDate() + 1);
        var edate = new Date(result);
        formSchema.tenative_start_date = edate.toJSON().substring(0,10)
        formSchema.tenative_end_date = '';
        formSchema.tentative_total_days = '';
      }
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    }, //proc_execution

    getDataFromApi() {
      commonService.getAllData("proc_package_eco").then((res) => {
        this.items = res.data;
        this.loading = false;
      });
    },
    loadData() {
      let formSchema = this.formSchema;
      commonService
        .getAllDataById(this.operation_act_id, "proc_package_eco")
        .then((res) => {
          if (res.data) {
            this.formSchema = res.data;
          }
          this.show = true;
        });
    },

    home() {
      this.$router.push("/procurement/package");
    },

    submitEcoHeadAmount() {
      let root = this;
      let pid = this.package_id
      // let pid = this.$store.getters.package_id
      this.formSchema[0].package_id = pid
      let formSchema = this.formSchema;
      if (this.$refs.form.validate()) {
        if(sessionStorage.getItem("package_status") == "update"){
            commonService.updateFormData(formSchema, 'proc-step-update').then(res => {              
              if(res.status == 1){
                  this.SnackbarVal.color = "success";
                  this.SnackbarVal.message = res.message;
                  this.SnackbarVal.snackbar = true;                  
              }else{
               this.SnackbarVal.color = "error";
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
            }
            }); 
        }else{
            commonService
          .insertFormData(formSchema, "proc_execution")
          .then((res) => {
            if (res.status == 1) {
              sessionStorage.setItem('package_status','update')
              this.SnackbarVal.color = "success";
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
              this.editItem()
              // this.$refs.form.reset();
              // this.$watch.method_id()

            }else{
               this.SnackbarVal.color = "error";
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
            }
          });
        }
        
      }
    },
    editItem() {
      // this.row_index = index;
      // this.formSchema = item;
      // window.scrollTo({
      //   top: 0,
      //   left: 100,
      //   behavior: "smooth",
      // });

      let path = serverPath.serverPath;
      this.formSchema = []
      let headers = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      };

      let instant_package_id = sessionStorage.getItem("package_info")
              ? sessionStorage.getItem("package_info")
              : this.package_id;
        Axios.get(path + "/api/proc_set_execution_steps/"+ instant_package_id+"/"+ this.method_id, headers)
        .then((res) => {
          let fetchData = res.data.data;
          this.formSchema = fetchData
          fetchData.forEach((current, index, fetchData) => {
            this.formSchema[index].tenative_start_date = current.start_date;
            this.formSchema[index].tentative_total_days = current.tentative_total_days;
            this.formSchema[index].tenative_end_date = current.end_date;
            this.formSchema[index].remarks = current.remarks;
            this.formSchema[index].tenative_value = current.value;
            this.formSchema[index].step_id = current.method_step_id;
            this.formSchema[index].package_id = current.package_id;
          });
          
          return this.formSchema;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_package_eco").then((res) => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
          //this.getDataFromApi();
        }
        this.message = res.message;
        this.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },
    previous() {
      this.$emit("emitForm3", 2);
    },

    close: function() {
      this.$refs.form.reset();
    },
  },
  mounted() {
    this.getDataFromApi();
  },
};
</script>

<style scoped>
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 2px solid #ddd;
  padding: 8px;
  text-align: left;
  width: 1%;
  white-space: nowrap;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(56, 134, 59);
  color: white;
}

#auto {
  overflow-x: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/procurement/package/step_forms/stepDateEntry.vue